var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Button',{attrs:{"variety":"submit","disabled":_vm.disabled},on:{"click":function($event){return _vm.handleClick($event)}}},[_vm._v(_vm._s(_vm.buttonLabel))])}
var staticRenderFns = []

export { render, staticRenderFns }